import { _ as __rest } from "./tslib.es6.js";
import React__default from "react";
import classNames from "classnames";
const defaultProps = {
  total: 3,
  current: 0,
  direction: "horizontal"
};
const classPrefix = `nut-indicator`;
const Indicator = (props) => {
  const _a = Object.assign(Object.assign({}, defaultProps), props), { total, current, children, className, direction } = _a, rest = __rest(_a, ["total", "current", "children", "className", "direction"]);
  const classes = classNames({
    [`${classPrefix}-vertical`]: direction === "vertical"
  });
  const renderElement = () => {
    const childs = [];
    for (let item = 0; item < total; item++) {
      childs.push(item === current ? children || React__default.createElement("div", { key: item, className: `${classPrefix}-dot ${classPrefix}-active` }) : React__default.createElement("div", { key: item, className: `${classPrefix}-dot` }));
    }
    return childs;
  };
  return React__default.createElement("div", Object.assign({ className: classNames(classPrefix, classes, className) }, rest), renderElement());
};
Indicator.defaultProps = defaultProps;
Indicator.displayName = "NutIndicator";
export {
  Indicator as I
};
